export var ButtonIconsEnum;
(function (ButtonIconsEnum) {
    ButtonIconsEnum["ADD"] = "add";
    ButtonIconsEnum["ARROW_DOWN"] = "arrowDown";
    ButtonIconsEnum["FILTER"] = "filter";
})(ButtonIconsEnum || (ButtonIconsEnum = {}));
export var LabelTypeEnum;
(function (LabelTypeEnum) {
    LabelTypeEnum["ISSUER"] = "Issuer";
    LabelTypeEnum["VERIFIER"] = "Verifier";
})(LabelTypeEnum || (LabelTypeEnum = {}));
export var TableCellTypeEnum;
(function (TableCellTypeEnum) {
    TableCellTypeEnum["TEXT"] = "text";
    TableCellTypeEnum["LABEL"] = "label";
})(TableCellTypeEnum || (TableCellTypeEnum = {}));
